import Axios from "axios";

const instance = Axios.create();
// export const API_URL = "https://stg.api.sarexpress.com";

// export const API_URL = "http://127.0.0.1:8000";

export const API_URL = process.env.VUE_APP_RUTA_API;

// export const API_URL = process.env.VUE_APP_RUTA_API_STG;



console.log(process.env);
const urls = {
  register: API_URL + "/api/cliente/registrar",
  particular: API_URL + "/api/particular/",
  confirmEmail: API_URL + "/api/confirm-email",
  pyme: API_URL + "/api/pyme/",
  changePassword: API_URL + "/api/change-password/",
  requestPobox: API_URL + "/api/request-pobox/",
  forgotPassword: API_URL + "/api/password-reset/",
  provincias:
    "https://apis.datos.gob.ar/georef/api/provincias?campos=id,nombre&orden=nombre",
  ciudades: (provinciaId) =>
    `https://apis.datos.gob.ar/georef/api/localidades?provincia=${provinciaId}&campos=id,nombre&orden=nombre&max=5000`
};

export function getRegisterValue() {
  return fetch(urls.register).then((response) => response.json());
}

export function getProvincias() {
  return fetch(urls.provincias).then((response) => response.json());
}

export function getMunicipios(provinciaId) {
  return fetch(urls.ciudades(provinciaId)).then((response) => response.json());
}

export function changePassword(token, password) {
  return fetch(urls.changePassword, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
  });
}

export function forgotPassword(email) {
  return fetch(urls.forgotPassword, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });}

export function requestPobox(email) {
  return fetch(urls.requestPobox, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
}

export function createParticularClient(cliente) {
  return fetch(urls.particular, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cliente),
  });
}

// export function createPymeClient(client) {
//   return fetch(urls.pyme, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(client),
//   });
// }

export function createPymeClient(payload) {
  return instance.post(urls.pyme, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  })
}



export function confirmEmail(token) {
  return fetch(urls.confirmEmail, {
    method: "POST",
    body: JSON.stringify({ token }),
    headers: { "Content-Type": "application/json" },
  });
}



export const getApi = (url) => {
  return instance.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
};

export const postApi = (url, data) => {
  return instance.post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
}


